import styled from "styled-components";

export const BgModal  = styled.div<{ show: boolean }>`
    background: rgba(50,70,91,0.8);
    display: ${props => props.show ? 'flex' : 'none'};
    flex: 1;
    position: fixed;
    width: 100%;
    height: 100%;
    z-index: 9;
    top: 0;
    justify-content: center;
    align-items: center;
    
`

export const BoxModal = styled.div`
    width: 90%;
    min-width: 280px;
    max-width: 400px;
    .topo{
        border-radius: 10px 10px 0 0;
        background: #dedede;
        font-size: 1.15rem;
        font-weight: bold;
        padding: 12px 14px;
        box-shadow: 0 7px 10px -5px rgba(0,0,0,0.9);
        text-transform: uppercase;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .content{
        background: #fff;
        font-weight: 400;
        padding: 12px 14px;
        border-radius: 0 0 10px 10px;
        box-shadow: 0 7px 10px -5px rgba(0,0,0,0.9);
        font-size: 0.95rem
    }
    @media(max-width: 280px){
      min-width: 270px;
    }
`